module.exports = __webpack_public_path__ + "static/media/android-ios.86429057.png";